import { getActionFromState, getStateFromPath, useNavigation } from '@react-navigation/native';
import * as Sentry from '@sentry/core';
import { useCallback } from 'react';

import { useAppContext } from '../components/AppContext';

export function useOpenDeeplink() {
  const navigation = useNavigation();
  const appContext = useAppContext();

  return useCallback(
    (path: string) => {
      const state = getStateFromPath(path, appContext.deeplinkConfig)!;
      if (!state) {
        Sentry.captureException('Invalid deeplink path', { extra: { path } });
        return;
      }
      navigation.dispatch(getActionFromState(state)!);
    },
    [appContext.deeplinkConfig, navigation],
  );
}
